import { createSiteToastApi } from '../helpers.js';
import '../helpers.js';

const showAlertMsg = createSiteToastApi({ durationMs: 4000, resizeNamespace: 'memberToastPlacement' });

export { showAlertMsg };
